import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Typography, CircularProgress, Container } from '@material-ui/core';
import LessonService from "./Locality/Service/lessonService";

const LessonDetail = () => {
  const { id } = useParams();
  const [lessons, setLessons] = useState(null);
  const [loading, setLoading] = useState(true);
    var [error, setError] = useState(null);

//   useEffect(() => {
   

//     fetchLesson();
//   }, [id]);

  useEffect(() => {
    getLessonList();

  
    return () => {
        setLessons([]);
    }
}, []);


const getLessonList = (classId) => {
    LessonService.findLessonList(classId).then((res) => {
     
        setLessons(res);
    }).catch((err) => {
        setError(err.message);
    });
}
  if (loading) return <CircularProgress />;

  return (
    <Container>
      <Typography variant="h4">{lessons.lesson}</Typography>
      <Typography variant="body1">Objectives: {lessons.objectives}</Typography>
      <Typography variant="body2">Remarks: {lessons.remarks}</Typography>
      {/* You can show images, steps, and video embed here too */}
    </Container>
  );
};

export default LessonDetail;
